import React from 'react';

import { LineSeparator } from '@/components/LineSeparator';
import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { AppSpacingProps } from '@/components/lib/theme';
import { common, designSystem } from '@/styles/styles';

export const PlayerRowSkeleton = ({
    showSeparator: isLastItem,
    mode = 'default',
    paddingVertical = 's16',
}: {
    showSeparator?: boolean;
    paddingVertical?: AppSpacingProps['paddingVertical'];
    mode?: 'default' | 'pickslip';
}) => {
    return (
        <>
            <Row alignItems={'center'} paddingVertical={paddingVertical}>
                <Box
                    backgroundColor={ds.colorToken.background.neutral.subtler}
                    borderRadius={'r10'}
                    style={common.borderCurve}
                    mr="s16"
                    ml={mode === 'default' ? 's0' : 's40'}
                >
                    <LoadingSkeleton
                        width={48}
                        height={68}
                        borderRadius="r10"
                        skeletonColor={designSystem.colors.neutral300}
                    />
                </Box>
                <Box gap="s6">
                    <Box
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        borderRadius={'r10'}
                        width={100}
                        style={common.borderCurve}
                    >
                        <LoadingSkeleton
                            width={100}
                            height={15}
                            skeletonColor={designSystem.colors.neutral300}
                            borderRadius={'r10'}
                        />
                    </Box>
                    <Box
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        borderRadius={'r10'}
                        width={80}
                        style={common.borderCurve}
                    >
                        <LoadingSkeleton
                            skeletonColor={designSystem.colors.neutral300}
                            borderRadius={'r10'}
                            height={15}
                            width={80}
                        />
                    </Box>
                    <Box
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        borderRadius={'r10'}
                        width={150}
                        style={common.borderCurve}
                    >
                        <LoadingSkeleton
                            skeletonColor={designSystem.colors.neutral300}
                            borderRadius={'r10'}
                            height={15}
                            width={150}
                        />
                    </Box>
                </Box>
                {mode === 'default' ? (
                    <Box
                        style={[common.marginLeftAuto, common.borderCurve]}
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        borderRadius={'r96'}
                        height={40}
                        width={40}
                    >
                        <LoadingSkeleton
                            skeletonColor={designSystem.colors.neutral300}
                            borderRadius={'r96'}
                            height={40}
                            width={40}
                        />
                    </Box>
                ) : null}
            </Row>
            {!isLastItem ? <LineSeparator style={common.separator} /> : null}
        </>
    );
};
